import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "@emailjs/browser";
import { useLocation } from "react-router-dom";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaWhatsapp } from "react-icons/fa6";

function ContactUs() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [id]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill out all required fields!");
      return;
    }

    emailjs
  .send(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    {
      name: formData.name,         // Corrected to match template
      email: formData.email,       // Corrected to match template
      phone: formData.phone,       // Corrected to match template
      message: formData.message, // Corrected to match template
    },
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY
  )
  .then(
    () => {
      toast.success("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" });
    },
    (error) => {
      toast.error("Error sending message! " + error.text);
    }
  );

  };

  useEffect(() => {
    if (location.pathname !== window.location.pathname) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <div className="bg-slate-900">
      <ToastContainer />
      <h1 className="text-5xl md:text-6xl text-center text-white font-thin pt-16 pb-20">
        Contact Us
      </h1>
      <div className="bg-slate-900 flex flex-col 2xl:flex-row justify-center items-center max-w-screen-2xl mx-auto">
        <div className="flex flex-col justify-center">
          <div className="flex flex-col items-center text-white">
            <div className="flex flex-wrap justify-center gap-8 lg:gap-10">
              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FontAwesomeIcon icon={faPhone} className="text-3xl text-black" />
                <h1 className="text-black">Phone</h1>
                <p className="text-black">+44 208 051 5530</p>
              </div>

              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FontAwesomeIcon icon={faEnvelope} className="text-3xl text-black" />
                <h1 className="text-black">Email</h1>
                <p className="text-black">info@1uklogistics.com</p>
              </div>

              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FaWhatsapp className="text-3xl text-black" />
                <h1 className="text-black">WhatsApp</h1>
                <p className="text-black">+44 786 249 4152</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center md:flex-row lg:gap-6 text-white">
            <div className="flex flex-col items-center text-center gap-2 lg:w-[400px] p-6 rounded-lg shadow-lg">
              <h1 className="font-semibold text-lg">Regional Office</h1>
              <p className="text-sm">17 Harbour House, Cold Harbour Lane, Rainham RM13 9YA, United Kingdom</p>
              <iframe
                className="w-full h-60 rounded-md mt-2"
                src="https://www.google.com/maps?q=51.520497,0.188444&hl=en&z=14&output=embed"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>

            <div className="flex flex-col items-center text-center gap-2 lg:w-[400px] p-6 rounded-lg shadow-lg">
              <h1 className="font-semibold text-lg">Registered Office</h1>
              <p className="text-sm">Unit 204 Sierra Quebec Bravo, (SQB) 77 Marsh Wall, London, England, E14 9SH</p>
              <iframe
                className="w-full h-60 rounded-md mt-2"
                src="https://www.google.com/maps?q=51.5010,-0.0221&hl=en&z=14&output=embed"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="w-full bg-slate-900 flex flex-col justify-center items-center p-3 md:pt-20 2xl:pt-0">
          <div className="bg-white p-6 md:p-8 rounded-sm w-full max-w-lg">
            <h2 className="text-left text-xl md:text-3xl font-thin mb-4 md:mb-6 text-black">
              Send a Message
            </h2>
            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  id="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
              </div>
              <div>
                <input
                  type="text"
                  id="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
              <div>
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>
              <div>
                <textarea
                  id="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
                  rows="4"
                ></textarea>
                {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
              </div>
              <div className="text-right">
                <button type="submit" className="w-fit py-2 px-6 border bg-black text-white font-thin hover:bg-white hover:text-black transition-all">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;


{/* <div className="flex flex-col justify-center">
          <div className="flex flex-col items-center text-white">
            <div className="flex flex-wrap justify-center gap-8 lg:gap-10">
              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FontAwesomeIcon icon={faPhone} className="text-3xl text-black" />
                <h1 className="text-black">Phone</h1>
                <p className="text-black">+44 208 051 5530</p>
              </div>

              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FontAwesomeIcon icon={faEnvelope} className="text-3xl text-black" />
                <h1 className="text-black">Email</h1>
                <p className="text-black">info@1uklogistics.com</p>
              </div>

              <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
                <FaWhatsapp className="text-3xl text-black" />
                <h1 className="text-black">WhatsApp</h1>
                <p className="text-black">+44 786 249 4152</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center md:flex-row lg:gap-6">
            <div className="flex flex-col items-center text-center gap-2 lg:w-[400px] p-6 rounded-lg shadow-lg">
              <h1 className="font-semibold text-lg">Regional Office</h1>
              <p className="text-sm">Harbour House, Coldharbour Ln, Rainham RM13 9YA, United Kingdom</p>
              <iframe
                className="w-full h-60 rounded-md mt-2"
                src="https://www.google.com/maps?q=51.520497,0.188444&hl=en&z=14&output=embed"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>

            <div className="flex flex-col items-center text-center gap-2 lg:w-[400px] p-6 rounded-lg shadow-lg">
              <h1 className="font-semibold text-lg">Registered Office</h1>
              <p className="text-sm">Unit 204 Sierra Quebec Bravo, (SQB) 77 Marsh Wall, London, England, E14 9SH</p>
              <iframe
                className="w-full h-60 rounded-md mt-2"
                src="https://www.google.com/maps?q=51.5010,-0.0221&hl=en&z=14&output=embed"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div> */}

// import React, { useState, useEffect } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import emailjs from "@emailjs/browser";
// import { useLocation } from "react-router-dom";
// import { faEnvelope, faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { FaWhatsapp } from "react-icons/fa6";

// function ContactUs() {
//   const location = useLocation();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     description: "",
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => ({ ...prev, [id]: value }));
//     setErrors((prevErrors) => ({ ...prevErrors, [id]: "" }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = "Name is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     if (!formData.phone.trim()) newErrors.phone = "Phone is required";
//     if (!formData.description.trim()) newErrors.description = "Message is required";

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       toast.error("Please fill out all required fields!");
//       return;
//     }

//     emailjs
//       .send(
//         process.env.REACT_APP_EMAILJS_SERVICE_ID,
//         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
//         {
//           from_name: formData.name,
//           from_email: formData.email,
//           from_phone: formData.phone,
//           from_message: formData.description,
//         },
//         process.env.REACT_APP_EMAILJS_PUBLIC_KEY
//       )
//       .then(
//         () => {
//           toast.success("Message sent successfully!");
//           setFormData({ name: "", email: "", phone: "", description: "" });
//         },
//         () => {
//           toast.error("Error sending message!");
//         }
//       );
//   };

//   useEffect(() => {
//     if (location.pathname !== window.location.pathname) {
//       window.scrollTo(0, 0);
//     }
//   }, [location.pathname]);

//   return (
//     <div className="bg-slate-900">
//       <h1 className="text-5xl md:text-6xl text-center text-white font-thin  pt-16 pb-20">
//         Contact Us
//       </h1>
//     <div className="bg-slate-900 flex  justify-center items-center">
       
//     {/* <div className="flex flex-col md:flex-row w-full   justify-center bg-slate-900 text-white items-center"> */}
      
//     <div className="flex flex-col justify-center">
//  {/* Contact Info Section */}
//  <div className="flex flex-col items-center text-white   ">
//         {/* <h3 className="text-3xl md:text-5xl font-thin mb-8 mt-8">Get In Touch</h3> */}
//         <div className="flex flex-wrap justify-center gap-8 md:gap-10">

//           <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px]  p-8">
//             <FontAwesomeIcon icon={faPhone} className="text-3xl text-black" />
//             <h1 className="text-black">Phone</h1>
//             <p className="text-black">+44 208 051 5530</p>
//           </div>

//           <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
//             <FontAwesomeIcon icon={faEnvelope} className="text-3xl text-black" />
//             <h1 className="text-black">Email</h1>
//             <p className="text-black">info@1uklogistics.com</p>
//           </div>

//           <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[230px] p-8">
//   <FaWhatsapp  icon={FaWhatsapp} className="text-3xl text-black" />
//   <h1 className="text-black">WhatsApp</h1>
//   <p className="text-black"> +44 786 249 4152</p>
// </div>
         
//         </div>
//       </div>
//     <div className="flex flex-col justify-center md:flex-row  gap-6 ">
//       {/* Regional Office */}
//       <div className="flex flex-col items-center text-center gap-2  w-[400px] p-6 rounded-lg shadow-lg">
//         {/* <FontAwesomeIcon icon={faMapMarkerAlt} className="text-3xl text-black" /> */}
//         <h1 className="font-semibold text-lg">Regional Office</h1>
//         <p className="text-sm">Harbour House, Coldharbour Ln, Rainham RM13 9YA, United Kingdom</p>
//         <iframe
//           className="w-full h-60 rounded-md mt-2"
//           src="https://www.google.com/maps?q=51.520497,0.188444&hl=en&z=14&output=embed"
//           allowFullScreen
//           loading="lazy"
//         ></iframe>
//       </div>

//       {/* Registered Office */}
//       <div className="flex flex-col items-center text-center gap-2 w-[400px] p-6 rounded-lg shadow-lg">
//         {/* <FontAwesomeIcon icon={faMapMarkerAlt} className="text-3xl text-black" /> */}
//         <h1 className="font-semibold text-lg">Registered Office</h1>
//         <p className="text-sm">Unit 204 Sierra Quebec Bravo, (SQB) 77 Marsh Wall, London, England, E14 9SH</p>
//         <iframe
//           className="w-full h-60 rounded-md mt-2"
//           src="https://www.google.com/maps?q=51.5010,-0.0221&hl=en&z=14&output=embed"
//           allowFullScreen
//           loading="lazy"
//         ></iframe>
//       </div>
//     </div>
//       </div>
  
//     {/* Right Side - Contact Form */}
//     <div className="w-full  bg-slate-900 flex flex-col justify-center items-center p-3">
//       {/* <h1 className="text-5xl md:text-6xl text-white font-thin mb-8 md:mb-12">
//         Contact Us
//       </h1> */}
//       <div className="bg-white p-6 md:p-8 rounded-sm w-full max-w-lg">
//         <h2 className="text-left text-xl md:text-3xl font-thin mb-4 md:mb-6 text-black">
//           Send a Message
//         </h2>
//         <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
//           <div>
//             <input
//               type="text"
//               id="name"
//               placeholder="Name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
//             />
//             {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//           </div>
//           <div>
//             <input
//               type="text"
//               id="phone"
//               placeholder="Phone Number"
//               value={formData.phone}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
//             />
//             {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//           </div>
//           <div>
//             <input
//               type="email"
//               id="email"
//               placeholder="Email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
//             />
//             {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//           </div>
//           <div>
//             <textarea
//               id="description"
//               placeholder="Message"
//               value={formData.description}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border-b border-black bg-transparent text-black placeholder-black focus:ring-2 focus:ring-white focus:outline-none transition-all"
//               rows="4"
//             ></textarea>
//             {errors.description && (
//               <p className="text-red-500 text-sm mt-1">{errors.description}</p>
//             )}
//           </div>
//           <div className="text-right">
//             <button
//               type="submit"
//               className="w-fit py-2 px-6 border bg-black text-white font-thin hover:bg-white hover:text-black transition-all"
//             >
//               Send Message
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   </div>
//   </div>
//   );
// }

// export default ContactUs;








// import React, { useState, useRef, useEffect } from 'react';
// import { toast, ToastContainer } from 'react-toastify'; // Import Toastify
// import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
// import emailjs from '@emailjs/browser';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import { useLocation } from 'react-router-dom';
// import { FaWhatsapp } from 'react-icons/fa6';

// function ContactUs() {
//   const location = useLocation();
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     description: '',
//   });

//   const [errors, setErrors] = useState({});
//   const formRef = useRef();

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });

//     // Clear the error for the current field
//     setErrors((prevErrors) => ({ ...prevErrors, [id]: '' }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Validate fields
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.email.trim()) newErrors.email = 'Email is required';
//     if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
//     if (!formData.description.trim()) newErrors.description = 'Message is required';

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       toast.error('Please fill out all required fields!');
//       return;
//     }

//     // Send email using emailjs
//     emailjs
//       .send(
//         process.env.REACT_APP_EMAILJS_SERVICE_ID,
//         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
//         {
//           from_name: formData.name,
//           from_email: formData.email,
//           from_phone: formData.phone,
//           from_message: formData.description,
//         },
//         process.env.REACT_APP_EMAILJS_PUBLIC_KEY
//       )
//       .then(
//         (result) => {
//           console.log('Success:', result.text);
//           toast.success('Message sent successfully!');
//           setFormData({ name: '', email: '', phone: '', description: '' });
//         },
//         (error) => {
//           console.error('Error:', error.text);
//           toast.error('Error sending message!');
//         }
//       );
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   return (
//     <div className="bg-black min-h-screen">
//       <ToastContainer /> {/* Toastify Container */}
//       <div
//         className="relative bg-cover bg-center h-[400px] md:h-[500px]"
//         style={{ backgroundImage: "url('images/conbg3.png')" }}
//       >
//         <div className="absolute inset-0 bg-black opacity-70"></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-black">
//           <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Contact Us</h1>
//           <p className="mt-2 text-base md:text-lg text-zinc-300">
//             Professional logistics solutions tailored to your needs.
//           </p>
//         </div>
//       </div>

//       <div className="flex flex-col md:flex-row lg:p-20 gap-10">
//         {/* Send a Message Section */}
//         <div className="w-full lg:w-1/2 flex justify-center items-center p-4">
//           <div className="bg-white bg-opacity-10 backdrop-blur-md p-6 md:p-8 rounded-lg shadow-lg max-w-xl w-full">
//             <h2 className="text-center text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-black">Send a Message</h2>
//             <form ref={formRef} className="space-y-8 md:space-y-12" onSubmit={handleSubmit}>
//               <div>
//                 <input
//                   type="text"
//                   id="name"
//                   placeholder="Name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded"
//                 />
//                 {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//               </div>
//               <div>
//                 <input
//                   type="text"
//                   id="phone"
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded"
//                 />
//                 {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//               </div>
//               <div>
//                 <input
//                   type="email"
//                   id="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded"
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//               </div>
//               <div>
//                 <textarea
//                   id="description"
//                   placeholder="Message"
//                   value={formData.description}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded"
//                   rows="4"
//                 ></textarea>
//                 {errors.description && <p className="text-red-500 text-sm mt-1">{errors.description}</p>}
//               </div>
//               <button
//                 type="submit"
//                 className="w-full py-2 mt-4 border border-zinc-500 rounded-3xl text-black font-semibold hover:bg-zinc-800 transition"
//               >
//                 Submit
//               </button>
//             </form>
//           </div>
//         </div>

//        {/* Contact Info Section */}
//  <div className="w-full lg:w-1/2 flex flex-col items-center  text-black justify-center p-4 space-y-8 mb-20 md:mb-0">
//  <p className="text-center text-base lg:text-lg max-w-lg">
//    We’d love to hear from you! Get in touch with us for any queries related to our services.
//    Our team is here to provide assistance and answer any questions you may have.
//  </p>

//  <div className="flex justify-center gap-8 md:gap-10">
//    <div className="flex flex-col items-center text-center gap-4">
//      <div className="flex flex-col items-center text-center space-y-2">
//      <FontAwesomeIcon icon={faPhone} className="text-2xl md:text-3xl text-primary" />
//     <span className="text-sm md:text-base">+0208 051 5530</span>

//      </div>
//      <div className="flex flex-col items-center text-center space-y-2">
//      <FontAwesomeIcon icon={faEnvelope} className="text-2xl md:text-3xl text-primary" />
//        <span className="text-sm md:text-base">info@1uklogistics.com</span>
//      </div>
//    </div>

//    <div className="flex flex-col items-center text-center gap-4">
//      <div className="flex flex-col items-center text-center space-y-2">
//      <FaWhatsapp className="text-2xl md:text-3xl text-primary" />
//        <span className="text-sm md:text-base">+07879 052 459</span>
//      </div>
//      <div className="flex flex-col items-center text-center space-y-2">
//      <FontAwesomeIcon icon={faMapMarkerAlt} className="text-2xl md:text-3xl text-primary" />
//        <span className="text-sm md:text-base">26 Skylines Village London Canary Wharf E14 9TS</span>
//      </div>
//    </div>
//  </div>
// </div>

//       </div>
//     </div>
//   );
// }

// export default ContactUs;





 


// import React from 'react';
// import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';

// function ContactUs() {
//   return (
//     <div className='bg-black min-h-screen'>
//       {/* Hero Section */}
//       <div className="relative bg-cover bg-center h-[500px]" style={{ backgroundImage: "url('images/conbg3.png')" }}>
//         <div className="absolute inset-0 bg-black opacity-70"></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-black">
//           <h1 className="text-5xl font-semibold">Contact Us</h1>
//           <p className="mt-2 text-lg text-zinc-300">Professional logistics solutions tailored to your needs.</p>
//         </div>
//       </div>



//     <div className=" flex flex-col md:flex-row text-black  p-20">

// <div className="w-full md:w-1/2 flex justify-center items-center p-8">
//         <div className="bg-white bg-opacity-10 backdrop-blur-md p-8 rounded-lg shadow-lg max-w-xl h-[600px] w-full">
//           <h2 className="text-center text-3xl font-bold mb-6">Send a Message</h2>
          
//           <form className="space-y-12">
//             <input 
//               type="text" 
//               placeholder="Name" 
//               className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded "
//             />
            
//             <input 
//               type="text" 
//               placeholder="Phone Number" 
//               className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded "
//             />

//             <select 
//               className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded "
//             >
//               <option className="bg-gray-800" value="">Select Query Type</option>
//               <option className="bg-gray-800" value="logistics">Logistics</option>
//               <option className="bg-gray-800" value="other">Other</option>
//             </select>

//             <textarea 
//               placeholder="Message" 
//               className="w-full px-4 py-2 border border-black bg-transparent text-black placeholder-black rounded "
//               rows="4"
//             ></textarea>

//             <button 
//               type="submit" 
//               className="w-full py-2 mt-4  border border-zinc-500 rounded-3xl text-black font-semibold  hover:bg-zinc-800 transition"
//             >
//               Submit
//             </button>
//           </form>
//         </div>
//       </div>


//       <div className="w-full md:w-1/2 flex flex-col justify-center p-8 space-y-6 ">
        
//         <p className="text-center  text-lg">
//         We’d love to hear from you! Get in touch with us for any queries related to our services.
//         Our team is here to provide assistance and answer any questions you may have.
//         </p>

//         <div className="flex flex-col gap-10">
//           <div className='flex  justify-around'>
//           <div className="flex flex-col gap-4 items-center">
//             <FaPhone className="text-3xl mr-2" />
//             <span>+1 (555) 123-4567</span>
//           </div>
//           <div className="flex flex-col gap-4 items-center">
//             <FaEnvelope className="text-3xl mr-2" />
//             <span>info@example.com</span>
//           </div>
//             </div>
          
//           <div className='flex justify-around'>
//           <div className="flex flex-col gap-4 items-center">
//             <FaWhatsapp className="text-3xl mr-2" />
//             <span>+1 (555) 987-6543</span>
//           </div>
//           <div className="flex flex-col gap-4 items-center">
//             <FaMapMarkerAlt className="text-3xl mr-2" />
//             <span>1234 Example St, City, Country</span>
//           </div>
//             </div>
         
//         </div>

//         <div className="pt-12 brightness-75">
//           <iframe
//             title="Location Map"
//             src="https://www.google.com/maps/embed?pb=!1m18..."
//             className="w-full h-64 rounded-lg"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//           ></iframe>
//         </div>
//       </div>

    
//     </div>

//     <div className="relative bg-cover bg-center  h-[500px]" style={{ backgroundImage: "url('images/conbg4.png')" }}>
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-black">
//           <h1 className="text-5xl font-semibold">We’re Always Ready to Deliver Excellence!</h1>
//           <div><button className='text-xl text-black h-12 w-48 mt-10 rounded-2xl bg-zinc-200'>ContactUs</button>  </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactUs;



